<template>
    <div class="body-inner">
        <header-component></header-component>
        <!-- SHOP CART -->
        <section id="shop-cart">
            <div class="container">
                <div class="shop-cart" v-if="$store.getters.productos.length">
                    <div class="table table-sm table-striped table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th class="cart-product-thumbnail">Producto</th>
                                    <th class="cart-product-remove"></th>
                                    <th class="cart-product-thumbnail">Versión</th>
                                    <th class="cart-product-name">Paquete</th>
                                    <th class="cart-product-price" align="right">Precio unitario</th>
                                    <th class="cart-product-quantity">Cantidad</th>
                                    <th class="cart-product-subtotal" align="right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="producto in $store.getters.productos">
                                    <tr :key="producto.id_producto">
                                        <td colspan="5">
                                            <div class="cart-product-thumbnail-name"><button class="btn" @click.prevent="deleteProduct(producto, $store.getters.productos)"><i class="fa fa-times"></i></button> {{ producto.nombre }}</div>
                                        </td>
                                        <td class="cart-product-quantity" colspan="2">
                                            <div class="quantity">
                                                <input type="button" class="minus" value="-" @click.prevent="changeQuantity(producto, 0)">
                                                <input type="number" class="qty" v-model="producto.cantidad" name="quantity" @keyup="calculaTotal($store.getters.productos)">
                                                <input type="button" class="plus" value="+" @click.prevent="changeQuantity(producto, 1)">
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-for="version in producto.versiones" :key="version.id">
                                        <td class="cart-product-remove">
                                            
                                        </td>
                                        <td class="cart-product-remove">
                                            <button class="btn" @click.prevent="deleteVersion(version, producto.versiones)"><i class="fa fa-times"></i></button>
                                        </td>
                                        <td>
                                            <div class="cart-product-thumbnail-name">{{ version.nombre }}</div>
                                        </td>
                                        <td class="cart-product-description">
                                            <p>{{ version.tipoCompra }}</p>
                                        </td>
                                        <td class="cart-product-price">
                                            <span class="amount">${{ version.precio.toFixed(2) }}</span>
                                        </td>
                                        <td class="cart-product-quantity">
                                            
                                        </td>
                                        <td class="cart-product-subtotal">
                                            <span class="amount">${{ version.subtotal.toFixed(2) }}</span>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col-lg-4"><router-link to="/productos" type="button" class="btn btn-light">Volver al catálogo</router-link>
                           
                        </div>
                        <div class="col-lg-8 text-right">
                            
                        </div>
                    </div>
                    <div class="row">
                        <hr class="space"/>
                        <div class="col-lg-6"></div>
                        <div class="col-lg-6 p-r-10 ">
                            <div class="table-responsive">
                                <h4>Subtotal</h4>
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <td class="cart-product-name">
                                                <strong>Total</strong>
                                            </td>
                                            <td class="cart-product-name text-right">
                                                <span class="amount color lead"><strong>${{ $store.getters.total.toFixed(2) }} MXN</strong></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="cart-product-name">
                                                <strong>Cupón aplicado</strong>
                                            </td>
                                            <td class="cart-product-name text-right">
                                                <span class="amount color lead"><strong>{{ $store.getters.cupon }}</strong></span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <router-link to="/checkout" class="btn icon-left float-right" v-if="$store.getters.productos.length"><span>Finalizar compra</span></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Footer -->
        <footer id="footer">
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; 2020 <a href="https://etciberoamerica.com/" target="_blank" rel="noopener">ETC IBEROAMÉRICA.</a> </div>
                </div>
            </div>
        </footer>
        <!-- end: Footer -->
    </div>
</template>

<script>
/* eslint-disable */
import HeaderComponent from './components/HeaderComponent'
export default {
  name: 'Carrito',
  components: {
    HeaderComponent
  },
  data() {
      return {
        model: {
            imagen: '',
        },
        total: 0,
        productos: []
      }
  },

  methods: {

    calculaTotal(productos) {
        let total = 0
        let selected = 0
        productos.forEach((producto) => {
            producto.versiones.forEach((version) => {
                // if(selected == 0 && this.$store.getters.cupon.toUpperCase() == 'HAZMASETC')
                //     version.subtotal = version.cantidad * version.precio
                // if(selected == 1 && this.$store.getters.cupon.toUpperCase() == 'HAZMASETC')
                //     version.subtotal = version.cantidad * 400
                // if(selected == 2 && this.$store.getters.cupon.toUpperCase() == 'HAZMASETC')
                //     version.subtotal = version.cantidad * 300
                // if(this.$store.getters.cupon.toUpperCase() != 'HAZMASETC')
                    version.subtotal = version.cantidad * version.precio

                total = total + version.subtotal
                selected++;
            })
        })
        this.$store.commit('setTotal', parseFloat(total.toFixed(2)))
    },

    async changeQuantity(producto, accion) {
        
        if(accion == 0){
            if((producto.cantidad - 1) <= 0)
                producto.cantidad = 1
            else
                producto.cantidad --
        }
            
        if(accion == 1)
            producto.cantidad ++

        producto.versiones.forEach((version) => {
            version.cantidad = producto.cantidad
            version.subtotal = version.cantidad * version.precio
        })

        if(this.$store.getters.usuario) {
            await this.updateDataNoForm(`api/carrito/${producto.id_producto}`, producto, '', '', null, 0, 2, null)
        }

        this.calculaTotal(this.$store.getters.productos)
    },

    async deleteVersion(version, versiones) {
        if(this.$store.getters.cupon == 'CHERBART2223') {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'No se pueden quitar productos, cuando se ocupa el cupón CHERBART2223.',
            })

            return
        }
        const indexVesion = versiones.findIndex(element => element.id_version == version.id_version)
        versiones.splice(indexVesion, 1)

        if(this.$store.getters.usuario) {
            this.openLoading()
            await axios.delete(apiKS + `api/carrito/${version.id_version}?tipo=1`, { headers })
            .then((response) => {
                Swal.close()
            })
            .catch( error => {
                Swal.close()
                this.catchError(error)
            })
        }

        this.calculaTotal(this.$store.getters.productos)
    },

    async deleteProduct(producto, productos) {
        const index = productos.findIndex(element => element.id_producto == producto.id_producto)
        productos.splice(index, 1)

        if(this.$store.getters.usuario) {
            this.openLoading()
            await axios.delete(apiKS + `api/carrito/${producto.id_producto}?tipo=2`, { headers })
            .then((response) => {
                Swal.close()
            })
            .catch( error => {
                Swal.close()
                this.catchError(error)
            })
        }

        this.calculaTotal(this.$store.getters.productos)
    }
  },
  async mounted() {
    const script = document.createElement('script')
    script.src = '/js/functions.js'
    script.id = 'functionScript'
    document.body.appendChild(script)

    this.calculaTotal(this.$store.getters.productos)
    
  },
    beforeDestroy() {
        const scriptElem = document.getElementById('functionScript'); 
        scriptElem.remove()
    }
}
</script>
